import { APIScope, FeatureFlagKey } from "@swivl-mono/types";
import { Navigate } from "react-router-dom";

import { isFeatureEnabled } from "../../Helpers/FeatureFlags/isFeatureEnabled";
import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";
import { DashboardView } from "../../Views/Dashboard/Dashboard.View";

/** Where `/` went before Pulse (ENG-3237), unchanged: for viewers Pulse isn't on for. */
export function LegacyLandingRedirect(): React.ReactElement {
  const canViewConversations = useHasPermission(APIScope.CONVERSATION_VIEW);
  const canViewCRM = useHasPermission(APIScope.USER_CRM_VIEW);
  const canViewLocationsAll = useHasPermission(APIScope.LOCATIONS_ALL_VIEW);
  const snowy = isFeatureEnabled(FeatureFlagKey.Snowy);

  if (canViewConversations) {
    return <Navigate to={snowy ? "/contact-center-v3" : "/contact-center"} replace />;
  }
  if (canViewCRM) {
    return <Navigate to="/crm" replace />;
  }
  if (canViewLocationsAll) {
    return <Navigate to={snowy ? "/properties-v3" : "/properties"} replace />;
  }

  return <DashboardView />;
}
